import { Link } from 'react-router-dom';

interface GameHomeLinkProps {
  className: string;
  iconOnly?: boolean;
}

export function GameHomeLink({ className, iconOnly = false }: GameHomeLinkProps) {
  return (
    <Link className={`game-home-link ${className}${iconOnly ? ' game-home-link--icon-only' : ''}`} to="/" aria-label="返回首页" title={iconOnly ? '返回首页' : undefined}>
      {iconOnly ? (
        <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
          <path d="m3.5 11.2 8.5-7 8.5 7" />
          <path d="M5.8 9.7v10h12.4v-10M9.5 19.7v-6h5v6" />
        </svg>
      ) : (
        <><span aria-hidden="true">←</span><span>返回首页</span></>
      )}
    </Link>
  );
}
